import * as React from 'react';
import * as styles from './BenefitCard.css';

interface IBenefitCardProps {
  title: React.ReactNode;
  description: React.ReactNode;
  backgroundImage: string;
}

export function BenefitCard({ title, description, backgroundImage }: IBenefitCardProps) {
  return (
    <article className={styles['container']}>
      <div
        style={{ backgroundImage: `url(${backgroundImage})` }}
        className={styles['image']}
        data-testid="BenefitCardImage"
      />

      <div className={styles['content']}>
        <div className={styles['title']} data-testid="BenefitCardTitle">
          {title}
        </div>
        <span data-testid="BenefitCardDescription">{description}</span>
      </div>
    </article>
  );
}
